const PricePerServingObserver = ({ servingCount }) => ({
  servingCount: servingCount || 60,
  init() {
    // Make sure Recharge widget is loaded
    const i = setInterval(() => {
      if (document.querySelector('recharge-subscription-widget')?.shadowRoot.querySelectorAll('.rc-price').length) {
        this.initObserver();
        clearInterval(i);
      }
    }, 100);
  },
  initObserver() {
    const targetNode = document.querySelector('recharge-subscription-widget').shadowRoot.querySelector('*');

    // Options for the observer (watch for character data changes)
    const config = { characterData: true, subtree: true, childList: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          // Disconnect the observer to prevent infinite loops
          observer.disconnect();
          this.updateRechargeCostPrice();
          observer.observe(targetNode, config);
        }
      }
    };

    // Create an observer instance linked to the callback function
    this.updateRechargeCostPrice();
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  },
  updateRechargeCostPrice() {
    const servingCount = this.servingCount || 60;
    document.querySelector('recharge-subscription-widget').shadowRoot.querySelectorAll('.rc-price:not(.strike-through)').forEach(i => {
      const priveValue = i.innerHTML.match(/(\-\-\>\$)(\d+)(\.\d+)?/);
      if (priveValue) {
        const number = parseFloat(priveValue[2] + (priveValue[3] || '')) / servingCount;
        const formattedNumber = number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        // Remove existing price per serving element if it exists
        i.querySelector('.price-per-serving')?.remove();

        // Create and append the new price per serving element
        const pricePerElement = document.createElement('span');
        pricePerElement.classList.add('price-per-serving');
        pricePerElement.style.fontWeight = 'normal';
        pricePerElement.style.fontSize = '0.8em';
        pricePerElement.appendChild(document.createTextNode(` ($${formattedNumber} / serving)`));
        i.appendChild(pricePerElement);
      }
    })
  },
})

document.addEventListener('alpine:init', () => {
  Alpine.data("PricePerServingObserver", PricePerServingObserver);
});
